import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentNav: "index",
    baseUrl: "", // 本地
    fileUrlHeader: "", // 本地
    // baseUrl: "http://192.168.0.242:7080", // 测试
    // fileUrlHeader: "http://192.168.0.242:7080", // 测试
    // baseUrl: "http://www.gzcia.com.cn/", // 线上
    // fileUrlHeader: "http://www.gzcia.com.cn/", // 线上
    // baseUrl: "http://120.76.141.14:801/", // 线上
    // fileUrlHeader: "http://120.76.141.14:801/", // 线上
  },
  mutations: {
    updateCurrentNav (state, val) {
      state.currentNav = val
    },
  },
  actions: {},
  modules: {},
})
